// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import type { AppState, NonOrgParticipant } from "src/types";
import { getRoleTitles, getNonOrgRecipients } from "src/reducers";
import { setRecipientRole, sendEmail } from "src/actions/email";
import { setEmailModalStage } from "src/actions/modal";
import * as emailModalStages from "src/constants/emailModalStages";

import InvitationModal from "src/components/InvitationModal";

type Props = {
  open: boolean,
  roles: Array<{ id: number, title: string, label: string }>,
  participants: NonOrgParticipant[],
  inProgress: boolean,
  onBack: Function,
  setParticipantRole: Function,
  sendWithInvites: Function,
  sendWithoutInvites: Function
};

const EmailRecipientsInvitationModal = ({
  sendWithInvites,
  sendWithoutInvites,
  ...restProps
}: Props) => {
  return (
    <InvitationModal
      {...restProps}
      title={i18n.t(k.INVITE_RECIPIENTS_TO_UNIFIZE)}
      cancelButton={{
        label: i18n.t(k.SEND_MAIL_WITHOUT_INVITES),
        action: sendWithoutInvites
      }}
      okButton={{
        label: i18n.t(k.SEND_WITH_INVITES),
        action: sendWithInvites
      }}
    />
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  roles: getRoleTitles(app),
  inProgress: app.email.sending,
  participants: getNonOrgRecipients(app),
  open: app.email.stage === emailModalStages.INVITE
});

const mapDispatchToProps = {
  onBack: () => setEmailModalStage(emailModalStages.WRITE),
  setParticipantRole: setRecipientRole,
  sendWithoutInvites: () => sendEmail(true),
  sendWithInvites: () => sendEmail(false)
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailRecipientsInvitationModal);
